import { UserLoginVerifyCard } from "@/features/session/components/UserLoginVerifyCard";
import { Stack } from "@mui/material";

const UserLoginVerifyPage = () => {
  return (
    <Stack alignItems="center">
      <UserLoginVerifyCard sx={{ width: "100%", maxWidth: 464 }} />
    </Stack>
  );
};

export default UserLoginVerifyPage;
